import { Input } from '@accure/ui';

import type { TaskDetails } from '@/task-manager/entities/task-details';

import { TaskAttribute } from '../task-attribute';

export type TaskReadOnlyFrontendProps = {
  task: TaskDetails;
};

export function TaskReadOnlyFrontend({ task }: TaskReadOnlyFrontendProps) {
  return (
    <TaskAttribute label="Device">
      <div className="space-y-4">
        <Input disabled value={task.device?.frontendLevel ?? '-'} />
        <Input disabled value={task.device?.fullFrontendId ?? '-'} />
      </div>
    </TaskAttribute>
  );
}
